import {
  canAccessExpansionFieldRoles,
  DATACENTER_LAYOUT_ROLE_PATTERNS,
} from "./commercialRoleAccess";
import { canViewerPermission, getViewerEmailFromStorage } from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";

export function datacenterLayoutPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.DATACENTER_LAYOUT);
}

export function canAccessDatacenterLayout(viewerEmail) {
  if (!datacenterLayoutPluginEnabled()) return false;
  const email = viewerEmail ?? getViewerEmailFromStorage();
  if (canViewerPermission(email, "canAccessDatacenterLayout", false)) return true;
  return canAccessExpansionFieldRoles(DATACENTER_LAYOUT_ROLE_PATTERNS, email);
}
